import {
	AVC_MELBOURNE_ID,
	AVC_SYDNEY_ID,
	AVC_BRISBANE_ID,
	AVC_PERTH_ID,
} from '../user/userTenantCheck';

// Roster display data only — not used for pay calculations. Dates that are announced
// annually (Grand Final Friday, Royal Queensland Show) should be confirmed each year.
const AU_STATE_BY_AVC_TENANT_ID = {
	[AVC_MELBOURNE_ID]: 'VIC',
	[AVC_SYDNEY_ID]: 'NSW',
	[AVC_BRISBANE_ID]: 'QLD',
	[AVC_PERTH_ID]: 'WA',
};

const ALL = ['VIC', 'NSW', 'QLD', 'WA'];

const PUBLIC_HOLIDAYS = [
	// 2026
	{ date: '2026-01-01', name: 'New Year\'s Day', states: ALL },
	{ date: '2026-01-26', name: 'Australia Day', states: ALL },
	{ date: '2026-03-02', name: 'Labour Day', states: ['WA'] },
	{ date: '2026-03-09', name: 'Labour Day', states: ['VIC'] },
	{ date: '2026-04-03', name: 'Good Friday', states: ALL },
	{ date: '2026-04-04', name: 'Easter Saturday', states: ['VIC', 'NSW', 'QLD'] },
	{ date: '2026-04-05', name: 'Easter Sunday', states: ['VIC', 'NSW', 'QLD'] },
	{ date: '2026-04-06', name: 'Easter Monday', states: ALL },
	{ date: '2026-04-25', name: 'Anzac Day', states: ALL },
	{ date: '2026-04-27', name: 'Anzac Day holiday', states: ['WA'] },
	{ date: '2026-05-04', name: 'Labour Day', states: ['QLD'] },
	{ date: '2026-06-01', name: 'Western Australia Day', states: ['WA'] },
	{ date: '2026-06-08', name: 'King\'s Birthday', states: ['VIC', 'NSW'] },
	{ date: '2026-08-12', name: 'Royal Queensland Show (Brisbane)', states: ['QLD'] },
	{ date: '2026-09-25', name: 'Friday before AFL Grand Final', states: ['VIC'] },
	{ date: '2026-09-28', name: 'King\'s Birthday', states: ['WA'] },
	{ date: '2026-10-05', name: 'Labour Day', states: ['NSW'] },
	{ date: '2026-10-05', name: 'King\'s Birthday', states: ['QLD'] },
	{ date: '2026-11-03', name: 'Melbourne Cup Day', states: ['VIC'] },
	{ date: '2026-12-25', name: 'Christmas Day', states: ALL },
	{ date: '2026-12-26', name: 'Boxing Day', states: ALL },
	{ date: '2026-12-28', name: 'Boxing Day holiday', states: ALL },

	// 2027
	{ date: '2027-01-01', name: 'New Year\'s Day', states: ALL },
	{ date: '2027-01-26', name: 'Australia Day', states: ALL },
	{ date: '2027-03-01', name: 'Labour Day', states: ['WA'] },
	{ date: '2027-03-08', name: 'Labour Day', states: ['VIC'] },
	{ date: '2027-03-26', name: 'Good Friday', states: ALL },
	{ date: '2027-03-27', name: 'Easter Saturday', states: ['VIC', 'NSW', 'QLD'] },
	{ date: '2027-03-28', name: 'Easter Sunday', states: ['VIC', 'NSW', 'QLD'] },
	{ date: '2027-03-29', name: 'Easter Monday', states: ALL },
	{ date: '2027-04-25', name: 'Anzac Day', states: ALL },
	{ date: '2027-04-26', name: 'Anzac Day holiday', states: ['QLD', 'WA'] },
	{ date: '2027-05-03', name: 'Labour Day', states: ['QLD'] },
	{ date: '2027-06-07', name: 'Western Australia Day', states: ['WA'] },
	{ date: '2027-06-14', name: 'King\'s Birthday', states: ['VIC', 'NSW'] },
	{ date: '2027-08-11', name: 'Royal Queensland Show (Brisbane)', states: ['QLD'] },
	{ date: '2027-09-24', name: 'Friday before AFL Grand Final', states: ['VIC'] },
	{ date: '2027-09-27', name: 'King\'s Birthday', states: ['WA'] },
	{ date: '2027-10-04', name: 'Labour Day', states: ['NSW'] },
	{ date: '2027-10-04', name: 'King\'s Birthday', states: ['QLD'] },
	{ date: '2027-11-02', name: 'Melbourne Cup Day', states: ['VIC'] },
	{ date: '2027-12-25', name: 'Christmas Day', states: ALL },
	{ date: '2027-12-27', name: 'Christmas Day holiday', states: ALL },
	{ date: '2027-12-26', name: 'Boxing Day', states: ALL },
	{ date: '2027-12-28', name: 'Boxing Day holiday', states: ALL },
];

// Clients lead assignment timing intentionally skips any public holiday date
// observed in Australia, including regional dates outside AVC's active states.
const ADDITIONAL_ANY_AU_PUBLIC_HOLIDAY_DATES = [
	// 2026
	'2026-01-07',
	'2026-02-09',
	'2026-02-17',
	'2026-02-18',
	'2026-02-25',
	'2026-03-03',
	'2026-03-06',
	'2026-03-20',
	'2026-03-23',
	'2026-04-07',
	'2026-05-08',
	'2026-05-27',
	'2026-07-03',
	'2026-07-10',
	'2026-07-17',
	'2026-07-24',
	'2026-08-03',
	'2026-08-21',
	'2026-08-26',
	'2026-10-02',
	'2026-10-08',
	'2026-10-16',
	'2026-10-22',
	'2026-11-02',
	'2026-11-25',
	'2026-11-27',

	// 2027
	'2027-01-06',
	'2027-02-08',
	'2027-02-24',
	'2027-03-02',
	'2027-03-30',
	'2027-05-07',
	'2027-05-31',
	'2027-08-02',
	'2027-10-01',
	'2027-10-07',
	'2027-10-15',
	'2027-10-21',
	'2027-11-01',
	'2027-11-26',
];

const anyAustralianPublicHolidayDates = new Set([
	...PUBLIC_HOLIDAYS.map(holiday => holiday.date),
	...ADDITIONAL_ANY_AU_PUBLIC_HOLIDAY_DATES,
]);

const holidayNamesByStateAndDate = PUBLIC_HOLIDAYS.reduce((acc, holiday) => {
	holiday.states.forEach((state) => {
		const key = `${state}:${holiday.date}`;
		acc[key] = acc[key] ? `${acc[key]} / ${holiday.name}` : holiday.name;
	});
	return acc;
}, {});

export const getAuStateForTenantId = (tenantId) => {
	return AU_STATE_BY_AVC_TENANT_ID[String(tenantId || '')] || null;
};

// Returns the holiday name for the given YYYY-MM-DD date in the given AU state, or null.
export const getPublicHolidayName = (dateString, stateCode) => {
	if (!dateString || !stateCode) {
		return null;
	}
	return holidayNamesByStateAndDate[`${stateCode}:${dateString}`] || null;
};

export const isAnyAustralianPublicHoliday = (dateString) => {
	return Boolean(dateString && anyAustralianPublicHolidayDates.has(dateString));
};
